import numbro from 'numbro'
import { useMemo } from 'react'
import { Pow18 } from '../config'
import { Ether } from '../types'
import { e2w, w2e } from '../utils/number'

export function useOrderFilledSize(
  quantity: number,
  unfilledQuantity: number,
): Ether {
  return useMemo(() => {
    return w2e(e2w(quantity).sub(e2w(unfilledQuantity)))
  }, [quantity, unfilledQuantity])
}

// Returns a string formatted as a percentage, e.g. 10.23%
export function useOrderFilledPercentage(
  size: Ether | number,
  filledSize: Ether | number,
): string {
  return useMemo(() => {
    return numbro(Number(filledSize) / Number(size)).format({
      output: 'percent',
      mantissa: 2,
    })
  }, [size, filledSize])
}

export function useOrderValue(size: Ether | number, price: number): Ether {
  return useMemo(() => {
    return w2e(e2w(size).mul(e2w(price)).div(Pow18))
  }, [price, size])
}

export function usePerpSize(quantity: number, multiplier: number): Ether {
  return useMemo(() => {
    return w2e(e2w(quantity).mul(e2w(multiplier)).div(Pow18))
  }, [quantity, multiplier])
}

export function usePerpFilledSize(
  quantity: number,
  unfilledQuantity: number,
  multiplier: string,
): Ether {
  return useMemo(() => {
    return w2e(
      e2w(quantity).sub(e2w(unfilledQuantity)).mul(e2w(multiplier)).div(Pow18),
    )
  }, [quantity, multiplier, unfilledQuantity])
}

export function calcOrderFilledSize(
  quantity: number,
  unfilledQuantity: number,
): Ether {
  return w2e(e2w(quantity).sub(e2w(unfilledQuantity)))
}

export function calcOrderValue(size: Ether | number, price: number): Ether {
  return w2e(e2w(size).mul(e2w(price)).div(Pow18))
}

export function calcPerpSize(quantity: number, multiplier: number): Ether {
  return w2e(e2w(quantity).mul(e2w(multiplier)).div(Pow18))
}

export function calcPerpFilledSize(
  quantity: number,
  unfilledQuantity: number,
  multiplier: string,
): Ether {
  return w2e(
    e2w(quantity).sub(e2w(unfilledQuantity)).mul(e2w(multiplier)).div(Pow18),
  )
}
